// extracted by mini-css-extract-plugin
export var infoItem = "_nm-2";
export var title = "_nm-0";
export var value = "_nm-1";